import { ShippingPolicyDialogLocalManager } from '@/components/ui-v2/shipping-policy/shipping-policy-dialog-localmanager';
import { DealItemWithVersions } from '@/lib/graphql/generated/graphql';
import {
  ShippingPolicy,
  ShippingPolicyState,
} from '@/lib/types/shipping-policy';

export function shouldHideShippingPolicyDialog({
  shippingPolicy,
  mode,
  isOfferLocked = false,
}: {
  shippingPolicy: ShippingPolicy | ShippingPolicyState;
  mode: 'validate' | 'edit';
  isOfferLocked?: boolean;
}): boolean {
  if (mode === 'edit' && ShippingPolicyDialogLocalManager.getDontShowAgain()) {
    return true;
  }

  const hasShippingPolicy =
    shippingPolicy.allShippingFeesZero ||
    ('freeShippingRules' in shippingPolicy
      ? shippingPolicy.freeShippingRules.length > 0 ||
        shippingPolicy.deliveryOfferedNumberOfDays !== null
      : shippingPolicy.minimumOrderEnabled ||
        shippingPolicy.timeLimitedEnabled);

  return hasShippingPolicy || isOfferLocked;
}

export function areAllShippingFeesZero(
  dealItems: DealItemWithVersions[]
): boolean {
  if (!dealItems || dealItems.length === 0) return false;

  const selectedItems = dealItems.filter(
    (item) => item.activeVersion.isSelected
  );
  if (selectedItems.length === 0) return false;

  return selectedItems.every((item) => item.activeVersion.shippingPrice === 0);
}
